module.exports = __webpack_public_path__ + "src/assets/img/door_left_back.1e054bd7.svg";